import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const withoutPage = ['La información queda repartida entre publicaciones.', 'Los clientes deben preguntar precios, ubicación y disponibilidad.', 'Tu negocio depende completamente de Instagram o Facebook.', 'Puede ser difícil mostrar todos tus productos o servicios.', 'Un cliente nuevo puede no entender rápidamente qué ofrecés.'];
const withPage = ['Toda la información está disponible en un solo enlace.', 'Tus productos o servicios se muestran de manera profesional.', 'El cliente llega a WhatsApp con mayor contexto.', 'Tu ubicación, horarios y redes están siempre visibles.', 'Tu negocio transmite más orden y confianza.'];
export function ProblemSolutionSection() {
  return <section className="bg-[#0c0c1c] py-24" data-id="element-1237">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1238">
        <div className="mx-auto max-w-3xl text-center" data-id="element-1239">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1240">
            Tu negocio ya existe. Ahora debe encontrarse bien en Internet.
          </p>
          <h2 className="text-3xl font-bold text-white md:text-5xl" data-id="element-1241">
            Tener redes sociales no siempre es suficiente.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#a9a9ba]" data-id="element-1242">
            Cuando una persona quiere conocer tu negocio, comparar opciones o
            consultar un servicio, necesita encontrar toda la información
            importante en un solo lugar.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-1243">
          <motion.article initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-white/10 bg-[#101022] p-7 md:p-8" data-id="element-1244">
            <div className="flex items-center gap-3" data-id="element-1245">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#e92a88]/10" data-id="element-1246">
                <XIcon className="h-5 w-5 text-[#f481ba]" data-id="element-1247" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-1248">
                Sin una página clara
              </h3>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-1249">
              {withoutPage.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#b9b9c7]" data-id="element-1250">
                  <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-[#e92a88]" data-id="element-1251" />
                  {item}
                </li>)}
            </ul>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-[#20d6e8]/25 bg-[#101022] p-7 md:p-8" data-id="element-1252">
            <div className="flex items-center gap-3" data-id="element-1253">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#20d6e8]/10" data-id="element-1254">
                <CheckIcon className="h-5 w-5 text-[#20d6e8]" data-id="element-1255" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-1256">
                Con tu Página A-Z
              </h3>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-1257">
              {withPage.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#d1d1dc]" data-id="element-1258">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-[#20d6e8]" data-id="element-1259" />
                  {item}
                </li>)}
            </ul>
          </motion.article>
        </div>

        <p className="mx-auto mt-9 max-w-3xl border-l-2 border-[#a738f4] pl-5 text-center text-base leading-relaxed text-[#d5d5df]" data-id="element-1260">
          No reemplazamos tus redes sociales. Creamos el lugar al que tus redes
          deben llevar a los clientes.
        </p>
      </div>
    </section>;
}